/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ValuePerBinderResponseDto } from './ValuePerBinderResponseDto';
import {
    ValuePerBinderResponseDtoFromJSON,
    ValuePerBinderResponseDtoFromJSONTyped,
    ValuePerBinderResponseDtoToJSON,
    ValuePerBinderResponseDtoToJSONTyped,
} from './ValuePerBinderResponseDto';

/**
 * 
 * @export
 * @interface TotalValuePerBinderResponseDto
 */
export interface TotalValuePerBinderResponseDto {
    /**
     * 
     * @type {string}
     * @memberof TotalValuePerBinderResponseDto
     */
    binderId: string;
    /**
     * 
     * @type {string}
     * @memberof TotalValuePerBinderResponseDto
     */
    binderName: string;
    /**
     * 
     * @type {ValuePerBinderResponseDto}
     * @memberof TotalValuePerBinderResponseDto
     */
    primary: ValuePerBinderResponseDto;
    /**
     * 
     * @type {ValuePerBinderResponseDto}
     * @memberof TotalValuePerBinderResponseDto
     */
    excessOfLossAndQuotaShare: ValuePerBinderResponseDto;
}

/**
 * Check if a given object implements the TotalValuePerBinderResponseDto interface.
 */
export function instanceOfTotalValuePerBinderResponseDto(value: object): value is TotalValuePerBinderResponseDto {
    if (!('binderId' in value) || value['binderId'] === undefined) return false;
    if (!('binderName' in value) || value['binderName'] === undefined) return false;
    if (!('primary' in value) || value['primary'] === undefined) return false;
    if (!('excessOfLossAndQuotaShare' in value) || value['excessOfLossAndQuotaShare'] === undefined) return false;
    return true;
}

export function TotalValuePerBinderResponseDtoFromJSON(json: any): TotalValuePerBinderResponseDto {
    return TotalValuePerBinderResponseDtoFromJSONTyped(json, false);
}

export function TotalValuePerBinderResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TotalValuePerBinderResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'binderId': json['binderId'],
        'binderName': json['binderName'],
        'primary': ValuePerBinderResponseDtoFromJSON(json['primary']),
        'excessOfLossAndQuotaShare': ValuePerBinderResponseDtoFromJSON(json['excessOfLossAndQuotaShare']),
    };
}

export function TotalValuePerBinderResponseDtoToJSON(json: any): TotalValuePerBinderResponseDto {
    return TotalValuePerBinderResponseDtoToJSONTyped(json, false);
}

export function TotalValuePerBinderResponseDtoToJSONTyped(value?: TotalValuePerBinderResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'binderId': value['binderId'],
        'binderName': value['binderName'],
        'primary': ValuePerBinderResponseDtoToJSON(value['primary']),
        'excessOfLossAndQuotaShare': ValuePerBinderResponseDtoToJSON(value['excessOfLossAndQuotaShare']),
    };
}

